import React from 'react';
import { useConversationItemStyles } from './styles';
import type { TimeLabelProps } from './types';

export const TimeLabel = ({ label }: TimeLabelProps) => {
  const styles = useConversationItemStyles();
  return (
    <li>
      <h4 className={styles.timeLabel}>
        {label}
      </h4>
    </li>
  );
};
